import numeral from 'numeral';

/**
 * Determines value to use for Highcharts tickInterval based on min and max values
 * @param minValue minimum possible value for axis
 * @param maxValue maxiumum possible value for axis
 * @returns
 */
export const getTickInterval = (minValue: number, maxValue: number): number | undefined => {
    const totalDistance = maxValue - minValue;

    if (totalDistance === 200) {
        return 50; // NPS
    }

    if (totalDistance === 100) {
        return 25; // top box
    }

    if (totalDistance <= 5) {
        return 1; // rating
    }

    // allow Highcharts to auto-determine
    return undefined;
};

export const safeNumeralFormat = (value: any, format = '0,0', fallback = '0') => {
    if (!value) return fallback;

    const numericValue = Number(value);

    if (Number.isNaN(numericValue)) return value;

    return numeral(numericValue).format(format);
};

export const extractPercentageFormat = (pointFormat: string | undefined): string => {
    if (!pointFormat) return '0.0';
    const formatMatch = pointFormat.match(/percentage:\.(\d+)f/);

    if (formatMatch && formatMatch[1]) {
        const precision = formatMatch[1];

        return `0.${'0'.repeat(parseInt(precision, 10))}`;
    }

    return '0.0';
};
